<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <event-table />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import EventTable from "./components/EventTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    EventTable,
    // ProjectsTable,
  },
};
</script>
